// extracted by mini-css-extract-plugin
export default {"separator":"XTCl7ow5KDwIoh9AaxiJ"};